import styled from "styled-components";

export const CardBadge = styled.div<{ $isPremium: boolean }>`
  top: 12px;
  right: 12px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 50px;
  color: white;
  background-color: ${(props) => (props.$isPremium ? "#FDCE40E5" : "#5575F7")};
`;